import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { editor } from '@/api/editor'
import { manuscript } from '@/api/manuscript'
import { macademic } from '@/api/macademic'
import {
  PRE_DECISION,
  FIRST_DECISION,
  FINAL_DECISION,
  DECISION_STATUS
} from '@/utils/dict'
import { getUploadConfig } from '@/utils/upload'
import SendEmail from '../../../manuscripts/dialog/send-email.dialog'
import customerReviewQuestion from '@/components/question.vue'

export default {
  components: { SendEmail, customerReviewQuestion },
  data() {
    return {
      // 取回数据
      reviewsResponse: {}, // 审稿人信息
      journalResponse: {}, // 稿件信息
      showVersion: false,
      showAcademic: false,
      showReviewer: false,
      // 填写数据 外编信息
      reviews: {
        macademicDecision: {
          editorNotes: '',
          authorNotes: ''
        },
        meditorDecision: ''
      },

      showSendEmail: false,
      inputData: {},
      event: '',
      files: [],
      rules: {},
      reviewerFileList: [],
      isMoreText: false,
      termList: PRE_DECISION,
      termListStatus: DECISION_STATUS,
      reviewerTogal: {},
      routeStatu: '',
      type: 'FIRST_CHECK',
      parmas: {},
      isView: false,
      // loading: false
      loadingAtt: false,
      loading: {
        reviewerFileList: false,
        authorReplyFileList: false
      },
      refuseList: [], // 拒绝理由列表
      selectReason: '', //
      isOpenItem: [], //控制每级面板的打开与折叠
      isSelectAll: [], //控制每级面板的选中状态
      othersReason: '',
      othersId: []
    }
  },
  async mounted() {
    this.routeStatu = this.$route.name
    this.getData()
    this.getRules()
    await this.getRefuseList()
    this.initData()
    if (this.type === 'FIRST_CHECK') {
      if (this.rules.authorNotes) {
        this.rules.authorNotes[0].required = false
      }
    }
    help.closeAutocomplete()
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      manuscriptType: 'getManuscriptType',
      country: 'getCountry',
      title: 'getTitle',
      user: 'getUser',
      domain: 'getDomain'
    })
  },
  watch: {
    // isMoreText:
  },
  methods: {
    getRules() {
      this.rules = {
        // authorNotes: [
        //   {
        //     required: true,
        //     message: 'Comments to Author' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        email: [
          {
            type: 'email',
            message: 'Email' + this.LANGUAGE[this.language].inputCorrectEmail
          }
        ]
      }
    },

    // 获取数据
    async getData() {
      let routeName = this.$route.name
      let { sign, manuscriptId } = this.$route.query
      let type = this.$route.params.type
      let data = {
        sign
      }
      if (
        routeName === '/editorial-office/manuscripts/decision-external/report'
      ) {
        this.isView = true
      } else {
        this.isView = false
      }
      switch (type) {
        case 'PRE_CHECK':
          this.termList = PRE_DECISION
          break
        case 'FIRST_CHECK':
          this.termList = FIRST_DECISION
          break
        case 'FINAL_CHECK':
          this.termList = FINAL_DECISION
          break
        default:
          this.termList = PRE_DECISION
          this.isView = true
      }
      this.type = type
      let res2 = await manuscript.info(manuscriptId, this.type, data)
      this.journalResponse = res2 ? res2 : []
      let res1 = await macademic.meditor(manuscriptId, this.type, data)
      this.reviewsResponse = res1 ? res1 : {}
      this.reviews.macademicDecision = this.reviewsResponse.macademicDecision
      this.reviews = Object.assign(this.reviews, {
        fileList: this.journalResponse.fileList
      })
      this.reviews &&
        this.reviews.fileList &&
        this.reviews.fileList.map(item => {
          item.authorShowed =
            item.authorShowed == undefined ? true : item.authorShowed
          return item
        })
      this.reviewerFileList =
        this.reviews &&
        this.reviews.macademicDecision &&
        this.reviews.macademicDecision.macademicFileList
          ? this.reviews.macademicDecision.macademicFileList
          : []
    },

    onChange() {},

    // 文件修改
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }
    },
    async addFile(file) {
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`
      this.loadingAtt = true
      const url = await getUploadConfig(file, path)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      const flag = this.reviewerFileList.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: url,
            file: file,
            authorShowed: val.authorShowed ? val.authorShowed : true,
            sort: val.sort
          }
          return true
        }
      })
      if (!flag) {
        this.reviewerFileList.push({
          name: file.name,
          size: file.size,
          path: url,
          file: file,
          authorShowed: true,
          sort: ''
        })
      }
      this.reviewerFileList.forEach((item, index) => {
        item.sort = item.sort ? item.sort : index
      })
      this.loadingAtt = false
    },

    // 文件修改
    // 文件上传
    async handleUpload1(files, itemrep, i, key) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile1(file, itemrep, key)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile1(file, itemrep, key)
          }
        })
      }
    },
    async addFile1(file, itemrep, key) {
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`

      this.uploadProgress = {
        current: 0,
        total: this.reviewerFileList.length
      }
      const pro_all = []
      this.loading[key] = true
      itemrep[key] = itemrep[key] ? itemrep[key] : []
      const flag =
        itemrep[key] &&
        itemrep[key].some(val => {
          if (file.name === val.name) {
            val = {
              id: '',
              name: file.name,
              size: file.size,
              description: '',
              path: '',
              file: file,
              authorShowed: val.authorShowed,
              sort: val.sort,
              reviewerSelf: val.reviewerSelf || true
            }
            return true
          }
        })
      if (!flag) {
        itemrep[key].push({
          id: '',
          name: file.name,
          size: file.size,
          description: '',
          path: '',
          file: file,
          authorShowed: true,
          sort: '',
          reviewerSelf: true
        })
      }
      itemrep[key].map((ele, i) => {
        ele.sort = ele.sort ? ele.sort : i

        ele.authorShowed =
          ele.authorShowed == undefined ? true : ele.authorShowed
        if (!ele.path) {
          pro_all[i] = getUploadConfig(ele.file, path)
            .then(res => {
              if (res && !res.includes('err:')) {
                this.uploadProgress.current++
              }
              return res
            })
            .then(res => {
              ele.path = res
              return res
            })
        } else {
          this.uploadProgress.current++
        }
      })
      const reses = await Promise.all(pro_all)
      this.loading[key] = false
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })
      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }
    },

    // 文件列表
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.reviewerFileList.splice(index, 1)
        } else {
          this.reviewerFileList = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },
    del1(item, index, key) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          item[key].splice(index, 1)
        } else {
          item[key] = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 保存
    async commit() {
      if (this.othersReason.length > 2048) {
        this.$message.error({
          title: 'Error',
          content: `The length of reason is too long and must be less than 2048 bytes.`
        })
        return
      }
      let flag = this.$refs['reviews-commit'].validate()
      let id = this.$route.params.id
      Object.assign(this.reviews, {
        reason: this.othersReason,
        reasonId: this.selectReason
      })
      this.parmas = this.reviews
      this.parmas.editorReviewerList = this.reviewsResponse.editorReviewerList
      // this.parmas.macademicDecision = this.reviewsResponse.editorReviewerList
      // console.log(this.parmas, '参数')

      if (!this.parmas.meditorDecision) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a decision status!'
        })
        return
      }
      if (
        (this.parmas.meditorDecision === 'REJECTED' ||
          this.parmas.meditorDecision === 'REJECTED_OR_REST') &&
        !this.selectReason
      ) {
        this.$message.error({
          title: 'Error',
          content: `Reject Reason can't be empty!`
        })
        return
      }

      if (
        (this.parmas.meditorDecision === 'REJECTED' ||
          this.parmas.meditorDecision === 'REJECTED_OR_REST') &&
        this.selectReason &&
        !this.othersReason.trim()
      ) {
        const flag = this.othersId.find(id => {
          return id === this.selectReason
        })
        if (flag) {
          this.$message.error({
            title: 'Error',
            content: `Reject Reason can't be empty!`
          })
          return false
        }
      }

      if (
        [
          'PENDING_MINOR_REVISIONS',
          'PENDING_MAJOR_REVISIONS',
          'ACCEPT_MINOR',
          'AFTER_MAJOR'
        ].includes(this.parmas.meditorDecision)
      ) {
        if (!this.parmas.reviseDueTime) {
          this.$message.error({
            title: 'Error',
            content: 'Please select a Revision Due Date!'
          })
          return
        }
        if (
          this.parmas.reviseDueTime &&
          this.$moment(this.parmas.reviseDueTime).diff(this.$moment()) < 0
        ) {
          this.$message.error({
            title: 'Error',
            content: 'Please select a right Revision Due Date!'
          })
          return
        }
      } else {
        this.parmas.reviseDueTime = null
      }

      if (
        !['REJECTED', 'REJECTED_OR_REST'].includes(this.parmas.meditorDecision)
      ) {
        this.othersReason = ''
        this.selectReason = ''
        this.parmas.reason = ''
        this.parmas.reasonId = ''
      }

      if (flag) {
        if (
          !['ACCEPT_CURRENT', 'PEER_REVIEW'].includes(
            this.reviews.meditorDecision
          ) &&
          !this.reviews.macademicDecision.authorNotes
        ) {
          this.$message.error({
            title: 'Error',
            content: 'Comments to Author' + this.LANGUAGE[this.language].noEmpty
          })
          return false
        }
        // await macademic.commitDecision(id, this.type, this.parmas)
        // this.$router.back(-1)
        this.sendEmail()
      }
    },

    cancel() {
      this.showSendEmail = false
      this.$router.back(-1)
    },

    async send() {
      let id = this.$route.params.id
      await macademic.commitDecision(id, this.type, this.parmas)
      this.cancel()
    },

    // 审稿人展开
    togalReviewer(item) {
      item.showReviewer == undefined
        ? (item.showReviewer = true)
        : (item.showReviewer = !item.showReviewer)
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },
    togalReport(item, type) {
      // item.showReport == undefined
      //   ? (item.showReport = true)
      //   : (item.showReport = !item.showReport)
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },
    // comments to Editor Author
    togalEditor(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },
    authorStatus(itemfile) {
      itemfile.authorShowed == undefined
        ? (itemfile.authorShowed = true)
        : (itemfile.authorShowed = !itemfile.authorShowed)
    },
    reviewAuthor(item) {
      item.authorShowed == undefined
        ? (item.authorShowed = true)
        : (item.authorShowed = !item.authorShowed)
    },
    // 发送邮件
    async sendEmail() {
      if (this.reviews.meditorDecision === 'PEER_REVIEW') {
        let id = this.$route.params.id
        await macademic.commitDecision(id, this.type, this.parmas)
        this.cancel()
        return
      }
      // const { id, submitter, meditor, journalId, sign } = this.reviewsResponse
      const { submitter, meditor } = this.reviewsResponse
      const { id, journalId, sign } = this.journalResponse
      this.inputData = {
        manuscriptId: id,
        sign,
        journalId,
        email: submitter && submitter.email,
        editorId: meditor && meditor.id,
        authorPersonId: submitter && submitter.id,
        editorPersonId: meditor && meditor.personId,
        reviseDueTime: this.reviews.reviseDueTime
      }
      const codes = {
        // 预审
        PEER_REVIEW: '',
        PENDING_MINOR_REVISIONS: 'MINOR_REVISION_FOR_MANUSCRIPT',
        PENDING_MAJOR_REVISIONS: 'MAJOR_REVISION_FOR_MANUSCRIPT',
        // 初审
        ACCEPT_CURRENT: 'ACCEPT_MANUSCRIPT',
        REJECTED: 'REJECT_MANUSCRIPT',
        REJECTED_OR_REST: 'REJECT_MANUSCRIPT',
        ACCEPT_MINOR: 'MINOR_REVISION_FOR_MANUSCRIPT',
        WITHDRAWN: 'WITHDRAW',
        AFTER_MAJOR: 'MAJOR_REVISION_FOR_MANUSCRIPT'
      }
      this.event = codes[this.reviews.meditorDecision]
      this.files =
        this.reviews.macademicDecision &&
        this.reviews.macademicDecision.macademicFileList &&
        this.reviews.macademicDecision.macademicFileList.filter(item => {
          return item.authorShowed
        })
      this.showSendEmail = true
    },
    // 状态切换
    changeStatus(statu) {
      this.reviews.meditorDecision = statu
      this.initData()
      this.selectReason = ''
      this.othersReason = ''
      if (this.type === 'FIRST_CHECK') {
        this.rules.authorNotes[0].required = false
      } else {
        if (['PEER_REVIEW'].includes(statu)) {
          this.rules.authorNotes[0].required = false
        } else {
          this.rules.authorNotes[0].required = true
        }
      }
    },
    addReviewer() {
      this.reviews.reviewerList.push({
        firstName: '',
        lastName: '',
        email: ''
      })
    },
    delReviewer(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this data?',
        content:
          'Please be aware of once this data is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.reviews.reviewerList.splice(index, 1)
        this.$message.success({
          title: 'Success',
          content: 'This Data has been deleted!'
        })
      })
    },
    showDecision(item) {
      let link = `/academic-menu/academic/detail/${item.decisionType}/${item.id}?manuscriptId=${item.manuscriptId}&sign=${item.sign}&status=${item.status}`
      window.location.href = link
    },
    changeDate(val) {
      if (val < this.$moment()) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a right Revision Due Date!'
        })
        return
      }
    },

    //拒绝理由列表
    async getRefuseList() {
      const params = {
        publisherId: this.publisherId,
        personId: ''
      }
      this.refuseList = await editor.refuse(params)
      this.initSetCheck()
      this.getOthersIds(this.refuseList)
    },

    // 处理Others
    getOthersIds(list) {
      const ids = []
      list &&
        list.map(item => {
          if (item.children) {
            item.children.map(child => {
              if (child.name === 'Others') {
                ids.push(child.id)
              }
            })
          }
        })

      this.othersId = ids
    },
    // 添加check属性
    initSetCheck() {
      this.refuseList.map(item => {
        if (item.children) {
          item.children.map(child => {
            Object.assign(child, {
              check: false
            })
          })
        }
      })
    },
    checkItem(index) {
      //展开或折叠面板
      this.othersReason = ''
      this.refuseList.map((item, root) => {
        if (item.children) {
          item.children.map((child, leaf) => {
            this.$set(child, 'check', false) // others
            this.$forceUpdate()
            this.$set(child, 'checked', false) // 节点选中
            this.$forceUpdate()
            this.$set(this.isOpenItem[root], 'group', false)
          })
        }
      })
      this.$set(this.isOpenItem[index], 'group', !this.isOpenItem[index].group)
    },

    stateChanged(item, index, i) {
      this.othersReason = ''
      this.selectReason = item.id
      if (item.name === 'Others') {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
        this.$set(item, 'check', true)
        this.$forceUpdate()
      } else {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
      }
      this.refuseList.map((item, root) => {
        this.$set(item, 'checked', false)
        if (item.children) {
          item.children.map((child, leaf) => {
            if (child.id == this.selectReason) {
              this.$set(child, 'checked', true)
              this.$forceUpdate()
              this.$set(item, 'checked', true)
              this.$forceUpdate()
              this.$set(this.isOpenItem[root], 'group', true)
              this.$forceUpdate()
              this.$set(this.isSelectAll[leaf], 'group', true)
              this.$forceUpdate()
            }
          })
        }
      })
    },

    initData() {
      //数据初始化
      let len = this.refuseList.length
      for (let i = 0; i < len; i++) {
        //根据数据初始化全选按钮状态
        this.isSelectAll.push([])
        // Object.assign(this.isSelectAll[i], { group: false })
        this.$set(this.isSelectAll[i], 'group', false)
        this.$set(this.isSelectAll[i], 'child', [])
        //根据数据初始化折叠面板折叠状态
        this.isOpenItem.push([])
        this.$set(this.isOpenItem[i], 'group', false)
        this.$set(this.isOpenItem[i], 'child', [])
        //设置第二层级的状态
        for (let j in this.refuseList[i].children) {
          this.isSelectAll[i].child.push(false)
          this.isOpenItem[i].child.push(false)
        }
      }
    }
  }
}
